<script lang="ts" setup>
const { siteName } = useSite()
</script>

<template>
  <div class="layout-footer">
    {{ siteName }}
  </div>
</template>
